// extracted by mini-css-extract-plugin
export var center = "_w-2";
export var clickableRow = "_w-5";
export var expandedRow = "_w-7";
export var hoverable = "_w-4";
export var left = "_w-1";
export var right = "_w-3";
export var row = "_w-0";
export var selectedRow = "_w-6";
export var summaryRow = "_w-8";